<template>
  <div class="inquiry-offers-form">
    <div class="card flex-row is-smallshadow mt-2 py-2 px-2 mx-auto">
      <f-button
        class="text-uppercase pr-1-sm"
        theme="go-back"
        withArrow
        withArrowBackwards
        @click.prevent="$bus.$emit('inquiry-offers-show-list')">
        <span v-pure-html="$t('inquiryOfferForm.backToComparingOffer')"></span>
      </f-button>

      <f-button
        class="ml-auto"
        theme="primary"
        :disabled="submitInProgress"
        @click.prevent="validateForm">
        <div
          v-if="submitInProgress"
          class="loading-spinner"
          role="status">
        </div>
        <template v-if="editMode">{{ $t('ui.saveChange') }}</template>
        <template v-else>{{ $t('ui.add') }}</template>
      </f-button>
    </div>

    <inquiry-offers-cart
      v-if="!editMode"
      :all-offers="allBankOffersForInquiryFormatted"
      :selected-props="selectedOffers" />

    <div class="card mt-2 mb-5 mx-auto">
      <div class="card-body">
        <h3 class="heading-medium mb-4">
          <template v-if="editMode">
            {{ $t('inquiryOfferForm.offerEdit') }}
          </template>
          <template v-else>
            {{ $t('dashboard.newOffer') }}
          </template>
        </h3>

        <f-accordion v-if="loaded">
          <f-accordion-item
            v-if="!editMode"
            :active="!editMode">
            <template slot="accordion-item-title">
              <strong class="heading-tiny mb-3 block">{{ $t('inquiryOfferForm.selectOfferForCustomer') }}</strong>
            </template>

            <template
              v-if="allBankOffersForInquiryFormatted.length"
              slot="accordion-item-content">

              <f-accordion class="pl-1">
                <f-accordion-item
                  v-for="(bank, bankIndex) in banksWithOffers"
                  :key="'bank-offer-' + bankIndex">
                  <template slot="accordion-item-title">
                    <strong class="heading-tiny mb-1 block">
                      {{ bank.name }} ({{ bank.offers.length }})
                      <f-badge
                        v-if="preferedBanks.indexOf(bank.id) > -1"
                        theme="dark"
                        class="ml-3"
                        style="top: -2px;">
                        {{ $t('inquiryOfferForm.selectCustomer') }}
                      </f-badge>
                    </strong>
                  </template>
                  <template slot="accordion-item-content">
                    <div
                      v-for="(offer, offerIndex) in bank.offers"
                      :key="'offer-' + offerIndex + '-' + offer.isDetailsVisible"
                      class="base-offer py-2 px-2 mb-2">
                      <inquiry-single-offer
                        v-if="isVisible"
                        :offer="offer"
                        :list-settings="listSettings"
                        :selected-props.sync="selectedOffers[offer.id]" />

                      <div
                        v-if="offer.variants.length"
                        class="base-offer-variants">
                        <div class="base-offer-variants-heading">
                          <h3 class="text-light-blue text-medium-light my-0 pr-2">
                            {{ $t('inquiryOfferForm.offerHaveVariant') }}:
                          </h3>
                          <div class="line">
                          </div>
                        </div>
                        <ul class="list-plain">
                          <li
                            v-for="(variant, variantIndex) in offer.variants"
                            :key="'bank-offer-' + offerIndex + '-' + variantIndex"
                            :class="{
                              'list-plain-item base-offer-variants-item': true,
                              'pt-1': variantIndex === 0,
                              'pt-2': variantIndex !== 0,
                              'pb-2': variantIndex < offer.variants.length - 1,
                              'pb-0': variantIndex === offer.variants.length - 1
                            }">
                            <inquiry-single-offer
                              v-if="isVisible"
                              :offer="variant"
                              :offer-variant-parent="offer"
                              :list-settings="listSettings"
                              :selected-props.sync="selectedOffers[offer.id].variants[variant.id]" />
                          </li>
                        </ul>
                      </div>

                    </div>
                  </template>
                </f-accordion-item>
              </f-accordion>
            </template>
          </f-accordion-item>
          <f-accordion-item
            :active="!!editMode"
            ref="accordion-item-offers"
            :toggleEvent="onOffersListToggle">
            <template slot="accordion-item-title">
              <strong class="heading-tiny mb-3 block">{{ $t('inquiryOfferForm.formOfferForCustomer') }}</strong>
            </template>
            <template slot="accordion-item-content">

              <validation-observer
                ref="inquiry-offers"
                tag="form"
                class="inquiry-offers">
                <template v-if="data.offers.length">
                  <div
                    class="offers-table common-data">
                    <div
                      v-for="(label, labelIndex) in offerLabels.filter(item => item.common)"
                      :key="'common-' + labelIndex"
                      class="offers-table-row mb-2 mb-3-xs">
                      <div class="offers-table-row-head mr-2 mr-0-xs mb-1-xs">
                        <template v-if="label.label">
                          <validation-provider
                            rules="required"
                            :name="'label-' + label.label"
                            v-slot="{ errors }">
                            <f-input
                              small
                              class="full-width"
                              v-model="label.value">
                            </f-input>
                           <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </validation-provider>
                        </template>
                        <template v-else>
                          <span class="my-auto text-bold">{{ label.value }}</span>
                        </template>
                      </div>
                      <div class="row-content-wrapper">
                        <div
                          class="row-content">
                          <validation-provider
                            :name="'value-' + label.label"
                            class="full-width"
                            v-slot="{ errors }">
                            <f-input-wrapper :append="label.append">
                              <f-input
                                min="1"
                                step="1"
                                type="number"
                                v-model="data[label.label]"
                                :disabled="true"
                                :state="errors.length ? 'invalid' : null"/>
                            </f-input-wrapper>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </validation-provider>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="isArrowsVisible"
                    class="flex flex-justify-content-between my-3 relative full-width arrow-wrapper">
                    <a
                      @click.prevent="showPrevItem"
                      href="#prev"
                      :class="{
                        'lnk arrow arrow-previous': true,
                        'is-disabled': !isArrowPrevVisible
                      }">
                      &laquo;
                    </a>
                    <a
                      @click.prevent="showNextItem"
                      href="#next"
                      :class="{
                        'arrow arrow-next': true,
                        'is-disabled': !isArrowNextVisible
                      }">
                      &raquo;
                    </a>
                  </div>

                  <div
                    :class="tableClasses">
                    <div
                      v-for="(label, labelIndex) in offerLabels.filter(item => !item.common && item.value !== $t('ui.action'))"
                      :key="'individual-' + labelIndex"
                      class="offers-table-row mb-2 mb-3-xs">
                      <div class="offers-table-row-head pr-2 pr-0-xs mb-1-xs">
                        <template v-if="label.label">
                          <validation-provider
                            rules="required"
                            :name="'label-' + label.label"
                            v-slot="{ errors }">
                            <f-input
                              small
                              class="full-width"
                              v-model="label.value">
                            </f-input>
                           <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </validation-provider>
                          <f-button
                            v-if="label.label === 'loan_installment'"
                            theme="text"
                            class="pt-1 px-0 py-0 ml-1 ml-4-xs pr-1-xs"
                            :disabled="!data.credit_amount"
                            @click.prevent.native="calculateLoanInstallment">
                            {{ $t('inquiryOfferForm.recalculate') }}
                          </f-button>
                          <f-button
                            v-if="label.label === 'fixed_loan_installment'"
                            theme="text"
                            class="pt-1 px-0 py-0 ml-1 ml-4-xs pr-1-xs"
                            :disabled="!data.credit_amount"
                            @click.prevent.native="calculateLoanInstallment('fixed')">
                            {{ $t('inquiryOfferForm.recalculate') }}
                          </f-button>
                        </template>
                        <template v-else>
                          <span
                            :class="{
                              'my-auto text-bold': true,
                              'hidden-mobile-tiny': label.value === $t('inquiry.titleMobile') || label.value === 'Bank'
                            }">
                            {{ label.value }}
                          </span>
                        </template>
                      </div>
                      <div
                        class="row-content-wrapper"
                        :ref="labelIndex === 1 ? 'offers-slider' : ''">
                        <div class="row-content row-slider"
                          :data-count="data.offers.length"
                          :data-current="currentSliderItem"
                          :style="{ transform: 'translateX(-' + (currentListOffset) + 'px)' }">
                          <div
                            v-for="(offer, offerIndex) in data.offers"
                            :key="'offer-' + offerIndex"
                            :class="{
                              'offers-table-row-cell': true
                            }">
                            <template v-if="label.value === 'Bank'">
                              <span class="block text-center text-size-medium text-medium">{{ offer.bank_name }}</span>
                            </template>
                            <template v-else-if="label.value === $t('inquiry.titleMobile')">
                              <span class="block text-center text-medium">{{ $t('inquiry.titleMobile') }}: {{ userType === 'customer' ? offer.customer_description_bank_offer || '-' : offer.bank_offer_name }}</span>
                              <span
                                v-if="offer.bank_offer_variant_id"
                                class="block text-center text-medium">
                                {{ $t('ui.variant') }}: {{ userType === 'customer' ? offer.customer_description_bank_variant_offer || '-' : offer.bank_offer_variant_name }}
                              </span>
                            </template>
                            <template v-else>
                              <validation-provider
                                :rules="label.rules"
                                :name="label.label + offerIndex"
                                v-slot="{ errors }">
                                <f-input-wrapper :append="label.append">
                                <f-input
                                  v-model="offer[label.label]"
                                  class="full-width"
                                  :type="label.rules ? 'number' : 'text'"
                                  :state="errors.length ? 'invalid' : null"/>
                              </f-input-wrapper>
                                <div class="invalid-feedback">
                                  {{ errors[0] }}
                                </div>
                              </validation-provider>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <f-alert
                    visible
                    theme="warning"
                    class="mx-3">
                    <span>
                      {{ $t('inquiryOfferForm.noSelectedBankForOffer') }}
                    </span>
                  </f-alert>
                </template>
              </validation-observer>
            </template>
          </f-accordion-item>
        </f-accordion>
      </div>

      <div class="mx-2 mt-3 mb-4">
        <f-button
          class="ml-auto block"
          theme="primary"
          big
          :disabled="submitInProgress"
          @click.prevent="validateForm">
          <div
            v-if="submitInProgress"
            class="loading-spinner"
            role="status">
          </div>
          <template v-if="editMode">{{ $t('ui.saveChange') }}</template>
          <template v-else>{{ $t('ui.add') }}</template>
        </f-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import FormUtils from '@/utils/FormUtils.js';
import CustomDecimals from '@/utils/CustomDecimals.js';
import debounce from 'lodash.debounce';
import InquiryOffersCart from './InquiryOffersCart.vue';
import InquirySingleOffer from './InquirySingleOffer.vue';

export default {
  name: 'inquiry-offer-form',
  components: {
    'inquiry-offers-cart': InquiryOffersCart,
    'inquiry-single-offer': InquirySingleOffer
  },
  props: {
    allBankOffersForInquiry: {
      type: Array,
      required: true
    },
    inquiryID: {
      type: Number,
      required: true
    },
    inquiryPropertyValue: {
      type: Number,
      required: true
    },
    inquiryNeedFinishingAmount: {
      type: Number,
      required: true
    },
    inquiryOwnContribution: {
      type: Number,
      required: true
    },
    labels: {
      type: Array,
      required: true
    },
    offerID: {
      required: true
    },
    offersInUse: {
      type: Array,
      required: true
    },
    preferedBanks: {
      type: Array,
      required: true
    }
  },
  computed: {
    listSettings () {
      let settingList =
      [
        {
          title: this.$t('inquiryOfferForm.commission'),
          variableName: ['commission'],
          type: 'String'
        },
        {
          title: this.$t('inquiryOfferForm.margin'),
          variableName: ['margin'],
          type: 'String'
        },
        {
          title: this.$t('inquiryOfferForm.wibor'),
          variableName: ['wibor'],
          type: 'String'
        },
        {
          title: this.$t('inquiryOfferForm.interestRate'),
          variableName: ['lending_rate'],
          type: 'String'
        },
        {
          title: this.$t('inquiryOfferForm.interestRateFixed'),
          variableName: ['fixed_lending_rate'],
          type: 'String'
        },
        {
          title: this.$t('inquiryOfferForm.bridgeInsurance'),
          variableName: ['bridging_insurance'],
          type: 'String'
        },
        {
          title: this.$t('inquiryOfferForm.lifeInsurance'),
          variableName: ['life_insurance'],
          type: 'String'
        },
        {
          title: this.$t('inquiryOfferForm.workInsurance'),
          variableName: ['work_insurance'],
          type: 'String'
        },
        {
          title: this.$t('inquiryOfferForm.estatesInsurance'),
          variableName: ['property_insurance'],
          type: 'String'
        },
        {
          title: this.$t('inquiryOfferForm.pricing'),
          variableName: ['valuation'],
          type: 'String'
        },
        {
          title: this.$t('inquiryOfferForm.earlyRepayment'),
          variableName: ['early_repayment_text'],
          type: 'String'
        }
      ];

      return settingList;
    },
    banksWithOffers () {
      let offersBanks = [];
      for (let i = 0; i < this.allBankOffersForInquiry.length; i++) {
        let exisitngBank = offersBanks.find(item => item.id === this.allBankOffersForInquiry[i].bank_id);

        let objCopy = { ...this.allBankOffersForInquiry[i] };

        if (exisitngBank) {
          exisitngBank.offers.push(objCopy);
        } else {
          let bankOfferObj = objCopy.bank;
          bankOfferObj.offers = [objCopy];
          offersBanks.push(bankOfferObj);
        }
      }

      return offersBanks.sort((a, b) => a.id - b.id);
    },
    allBankOffersForInquiryFormatted () {
      if (!this.allBankOffersForInquiry.length) {
        return [];
      }

      return this.allBankOffersForInquiry.map((offer) => {
        offer.bank_offer_name = offer.name;
        offer.bank_id = offer.bank_id;
        offer.bank_name = offer.bank.name;
        offer.wibor = 0;

        if (this.editMode) {
          // when editing previously added offer we show wibor value saved at the moment when offer was added
          offer.wibor = offer.wibor;
        } else if (offer.bank.wibor_type && offer.bank.wibor_type.value) {
          // when choosing new offer to add we display current wibor value for bank
          offer.wibor = offer.bank.wibor_type.value;
        }

        offer.commission = offer.commission;
        offer.margin = offer.margin;
        offer.lending_rate = offer.lending_rate;
        offer.fixed_lending_rate = offer.fixed_lending_rate;
        offer.loan_installment = null;
        offer.fixed_loan_installment = null;
        offer.bridging_insurance = offer.bridging_insurance_text;
        offer.life_insurance = offer.life_insurance_text;
        offer.work_insurance = offer.work_insurance_text;
        offer.property_insurance = offer.property_insurance_text;
        offer.valuation = offer.valuation_text;

        let variantsTmp = [];
        for (let i = 0; i < offer.variants.length; i++) {
          let variant = { ...offer.variants[i] };

          variant.bank_id = offer.bank_id;
          variant.bank_offer_name = offer.name;
          variant.bank_offer_variant_name = variant.name;
          variant.bank_name = offer.bank.name;
          variant.wibor = variant.wibor || offer.wibor;

          // for below four the value for display is: {value from offer} - {value from offer variant}
          variant.commission = variant.influence_on_commission ? CustomDecimals.roundProperly(offer.commission - variant.commission) : offer.commission;
          variant.margin = variant.influence_on_margin ? CustomDecimals.roundProperly(offer.margin - variant.margin) : offer.margin;
          variant.lending_rate = variant.influence_on_lending_rate ? CustomDecimals.roundProperly(offer.lending_rate - variant.lending_rate) : offer.lending_rate;
          variant.fixed_lending_rate = variant.influence_on_fixed_lending_rate ? CustomDecimals.roundProperly(offer.fixed_lending_rate - variant.fixed_lending_rate) : offer.fixed_lending_rate;

          variant.loan_installment = null;
          variant.fixed_loan_installment = null;
          variant.bridging_insurance = variant.influence_on_bridging_insurance ? variant.bridging_insurance_text : offer.bridging_insurance_text;
          variant.life_insurance = variant.influence_on_life_insurance ? variant.life_insurance_text : offer.life_insurance_text;
          variant.work_insurance = variant.influence_on_work_insurance ? variant.work_insurance_text : offer.work_insurance_text;
          variant.property_insurance = variant.influence_on_property_insurance ? variant.property_insurance_text : offer.property_insurance_text;
          variant.valuation = variant.influence_on_property_valuation ? variant.valuation_text : offer.valuation_text;

          variant.early_repayment_text = offer.early_repayment_text;

          variantsTmp.push(variant);
        }

        offer.variants = variantsTmp;

        return offer;
      });
    },
    tableClasses () {
      let classes = ['offers-table', 'with-slider', `rows-count-${this.data.offers.length}`];
      if (!this.isArrowsVisible) {
        classes.push('mt-5');
      }
      return classes.join(' ');
    },
    listFullWidth () {
      return this.sliderItemWidth * this.offersCount;
    },
    isArrowPrevVisible () {
      if ((this.currentSliderItem === 0) || (this.listFullWidth <= this.sliderListWidth)) {
        return false;
      }

      return true;
    },
    isArrowNextVisible () {
      if (this.currentSliderItem === this.offersCount - 1) {
        return false;
      }

      if (this.currentListOffset >= (this.listFullWidth - this.sliderListWidth)) {
        return false;
      }

      return true;
    },
    currentListOffset () {
      return this.currentSliderItem * this.sliderItemWidth;
    },
    sliderListWidth () {
      if (!this.windowWidth || !this.sliderList) {
        return 0;
      }
      return this.sliderList.offsetWidth;
    },
    isArrowsVisible () {
      if (this.editMode) {
        return false;
      }

      if ((this.windowWidth > 1130 && this.offersCount <= 3)) {
        return false;
      }

      if ((this.windowWidth > 720 && this.windowWidth <= 1130 && this.offersCount <= 2)) {
        return false;
      }

      if (this.offersCount <= 1) {
        return false;
      }

      return true;
    },
  },
  watch: {
    'data.need_finishing_amount': function () {
      this.recalculateCreaditAmount();
    },
    'data.own_contribution': function () {
      this.recalculateCreaditAmount();
    },
    'data.property_value': function () {
      this.recalculateCreaditAmount();
    },
    'data.offers': function () {
      Vue.set(this, 'currentSliderItem', 0);
      if (!this.sliderList) {
        this.sliderList = this.getSliderList();
      }
      Vue.nextTick(() => {
        Vue.set(this, 'offersCount', this.data.offers.length);

        if (this.sliderList) {
          setTimeout(() => {
            let item = this.sliderList.querySelector('.row-slider .offers-table-row-cell');
            if (item) {
              Vue.set(this, 'sliderItemWidth', item.offsetWidth);
            }
          }, 350);
        }
      })
    },
    'offersListVisible': function () {
      if (!this.sliderList) {
        this.sliderList = this.getSliderList();
      }
      Vue.nextTick(() => {
        if (this.sliderList) {
          setTimeout(() => {
            let item = this.sliderList.querySelector('.row-slider .offers-table-row-cell');
            if (item) {
              Vue.set(this, 'sliderItemWidth', item.offsetWidth);
            }
          }, 350);
        }
      })
    }
  },
  data() {
    return {
      data: {
        id: 0,
        credit_amount: 0,
        inquiry_id: 0,
        need_finishing_amount: 0,
        own_contribution: 0,
        property_value: 0,
        offers: []
      },
      loaded: false,
      selectedOffers: {},
      editMode: false,
      isHidden: true,
      submitInProgress: false,
      isVisible: false,
      actionInProgress: false,
      offerLoanInstallmentLoaded: false,
      offerLabels: [],
      currentSliderItem: 0,
      windowWidth: null,
      offersListVisible: false,
      offersCount: 0,
      sliderItemWidth: 0,
      sliderList: null,
      userType: null
    };
  },
  mounted () {
    this.$bus.$on('offer-selected', this.selectOffer);
    this.editMode = !!this.offerID;
    this.userType = this.$store.getters['getUserType'].toLowerCase();
    window.addEventListener('resize', this.debouncedResizeHandler);
    this.resetSelectedBanks();
    this.offerLabels = JSON.parse(JSON.stringify(this.labels));
    this.loadOffer();
    this.windowWidth = window.innerWidth;
  },
  methods: {
    loadOffer() {
      this.editMode = !!this.offerID;
      this.resetSelectedBanks();

      this.data.inquiry_id = this.inquiryID;

      if (this.editMode) {
        this.data.id = this.offerID;
        this.loadItemData();
      } else {
        this.data.id = 0;
        this.data.credit_amount = 0;
        this.data.need_finishing_amount = this.inquiryNeedFinishingAmount;
        this.data.own_contribution = this.inquiryOwnContribution;
        this.data.property_value = this.inquiryPropertyValue;
        this.data.offers = []

        this.loaded = true;
      }

      setTimeout(() => {
        this.isVisible = true;
        this.submitInProgress = false;
        if (this.$refs['offer-popup-form']) {
          this.$refs['offer-popup-form'].reset();
        }
      }, 0);
    },
    loadItemData() {
      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: '/api/adviser/inquiries/bank-offers/item/' + this.offerID,
        loadedKey: 'loaded',
        outputKey: 'data',
        outputKeyIndex: 'offers',
        pagination: false,
        wrapResponseIntoArray: true,
        successAction: () => {
          Vue.nextTick(() => {
            this.data.credit_amount = this.data.offers[0].credit_amount;
            this.data.need_finishing_amount = this.data.offers[0].need_finishing_amount;
            this.data.own_contribution = this.data.offers[0].own_contribution;
            this.data.property_value = this.data.offers[0].property_value;
            this.recalculateCreaditAmount();
          });
        }
      });
    },
    validateForm () {
      if (!this.data.offers.length) {
        this.showValidationFailed();
        return;
      }
      FormUtils.validate(this.$refs['inquiry-offers'], this.submitForm, this.showValidationFailed);
    },
    submitLabels () {
      let labelsToSend = [];

      for (let i = 0; i < this.offerLabels.length; i++) {
        if (this.offerLabels[i].label) {
          labelsToSend.push({
            label: this.offerLabels[i].label,
            value: this.offerLabels[i].value
          })
        }
      }
      let formDataToSend = {
        inquiry_id: this.inquiryID,
        labels: labelsToSend,
      }

      FormUtils.submitInBackground(this, {
        endpoint: '/api/adviser/inquiries/offer-labels/save',
        params: formDataToSend,
        errorTitle: this.$t('ui.errorOccurred'),
        errorText: this.$t('inquiryOfferForm.offerSaveError'),
        successAction: () => {
          this.$bus.$emit('inquiry-reload', 'inquiry-offers');
        },
        failAction: () => {
          this.offerLabels = this.labels;
          this.$bus.$emit('inquiry-reload', 'inquiry-offers');
        }
      });
    },
    submitForm () {
      let formDataToSend = this.prepareFormDataToSend();
      let endpointUrl = '/api/adviser/inquiries/bank-offers/store';

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: this.$t('inquiryForm.saveOffer'),
        successText: this.$t('inquiryForm.offerHasBeenSave'),
        errorTitle: this.$t('ui.errorOccurred'),
        errorText: this.$t('inquiryForm.modifyOfferError'),
        successAction: () => {
          this.submitLabels();
          this.$bus.$emit('inquiry-offers-reload', true);
        }
      });
    },
    prepareFormDataToSend () {
      let formDataToSend = {};

      formDataToSend = {
        inquiry_id: this.data.inquiry_id,
        offers: this.data.offers
      };

      for (let i = 0; i < formDataToSend.offers.length; i++) {
        formDataToSend.offers[i].credit_amount = this.data.credit_amount;
        formDataToSend.offers[i].need_finishing_amount = this.data.need_finishing_amount;
        formDataToSend.offers[i].own_contribution = this.data.own_contribution;
        formDataToSend.offers[i].property_value = this.data.property_value;
      }

      return formDataToSend;
    },
    resetSelectedBanks () {
      for (let i = 0; i < this.allBankOffersForInquiryFormatted.length; i++) {
        let offer = this.allBankOffersForInquiryFormatted[i];
        let offerInUse = this.offersInUse.find(item => item.offerID === offer.id && item.offerVariantID === 0);

        this.selectedOffers[offer.id] = {
          selected: !!offerInUse,
          variants: {},
          disabled: !!offerInUse
        };

        for (let j = 0; j < offer.variants.length; j++) {
          let variantInUse = this.offersInUse.find(item => item.offerID === offer.id && item.offerVariantID === offer.variants[j].id);

          let isDisabled = !!variantInUse;
          let excludedByTxt = '';

          // check if any of selected variants in this offer excludes this one
          let otherVariantExcludingThisOne = offer.variants.filter(item => item.excluded_variants.indexOf(offer.variants[j].id) > -1).map(item => item.id);
          let otherSelectedVariantExcludingThisOne = this.offersInUse.filter((item => item.offerID === offer.id && otherVariantExcludingThisOne.indexOf(item.offerVariantID) > -1));

          if (otherSelectedVariantExcludingThisOne.length) {
            for (let k = 0; k < otherSelectedVariantExcludingThisOne.length; k++) {
              let excludingOfferVariant = this.allBankOffersForInquiryFormatted.find(item => item.id === otherSelectedVariantExcludingThisOne[k].offerID).variants.find(item => item.id === otherSelectedVariantExcludingThisOne[k].offerVariantID);

              if (k > 0) {
                excludedByTxt += '; ';
              }

              if (excludingOfferVariant) {
                excludedByTxt += excludingOfferVariant.name;
              }
            }
          }

          this.selectedOffers[offer.id].variants[offer.variants[j].id] = {
            selected: !!variantInUse,
            disabled: isDisabled,
            excludedBy: excludedByTxt
          };
        }
      }
    },
    selectOffer (newValue, offerID, variantID) {
      if (variantID) {
        this.selectedOffers[offerID].selected = this.selectedOffers[offerID].selected;

        let offer = this.allBankOffersForInquiryFormatted.find(item => item.id === offerID);
        let currentVariant = offer.variants.find(item => item.id === variantID);
        let variantExcludes = currentVariant.excluded_variants;

        if (newValue) {
          this.addBankOfferToOffer(offerID, variantID);
        } else {
          this.removeBankOfferFromOffer(offerID, variantID);
        }

        this.selectedOffers[offerID].variants[variantID].selected = newValue;

        if (variantExcludes.length) {
          for (let i = 0; i < offer.variants.length; i++) {
            if (variantExcludes.indexOf(offer.variants[i].id) > -1) {
              this.selectedOffers[offerID].variants[offer.variants[i].id].excludedBy = newValue ? currentVariant.name : null;
            }
          }
        }
      } else if (newValue) {
        this.selectedOffers[offerID].selected = true;
        this.addBankOfferToOffer(offerID);
      } else {
        this.selectedOffers[offerID].selected = false;
        this.removeBankOfferFromOffer(offerID);
      }

      let copy = JSON.parse(JSON.stringify(this.selectedOffers));
      Vue.set(this, 'selectedOffers', copy);
    },
    addBankOfferToOffer (offerID, variantID = null) {
      let offer = {};
      let baseOffer = null;
      let offerParent = null;

      if (variantID) {
        offerParent = this.allBankOffersForInquiryFormatted.find(item => item.id === offerID);
        baseOffer = offerParent.variants.find(item => item.id === variantID);
        offer.bank_offer_variant_id = variantID;
        offer.bank_offer_variant_name = baseOffer.bank_offer_variant_name;
      } else {
        baseOffer = this.allBankOffersForInquiryFormatted.find(item => item.id === offerID);
        offer.bank_offer_variant_id = 0;
      }

      if (!baseOffer) {
        return;
      }

      offer.bank_offer_id = offerID;
      offer.loan_installment = null;
      offer.fixed_loan_installment = null;

      if (offerParent) {
        offer.bank_name = baseOffer.bank_name || offerParent.bank_name;
        offer.bank_offer_name = baseOffer.bank_offer_name || offerParent.bank_offer_name;
        offer.bank_id = baseOffer.bank_id || offerParent.bank_id;
        offer.commission = baseOffer.commission || offerParent.commission;
        offer.margin = baseOffer.margin || offerParent.margin;
        offer.wibor = baseOffer.wibor || offerParent.wibor;
        offer.lending_rate = baseOffer.lending_rate || offerParent.lending_rate;
        offer.fixed_lending_rate = baseOffer.fixed_lending_rate || offerParent.fixed_lending_rate;
        offer.bridging_insurance = baseOffer.bridging_insurance_text || offerParent.bridging_insurance_text;
        offer.life_insurance = baseOffer.life_insurance_text || offerParent.life_insurance_text;
        offer.work_insurance = baseOffer.work_insurance_text || offerParent.work_insurance_text;
        offer.property_insurance = baseOffer.property_insurance_text || offerParent.property_insurance_text;
        offer.valuation = baseOffer.valuation_text || offerParent.valuation_text;
        offer.early_repayment = baseOffer.early_repayment_text || offerParent.early_repayment_text;
        offer.early_overpayment = baseOffer.early_overpayment_text || offerParent.early_overpayment_text;
      } else {
        offer.bank_name = baseOffer.bank_name;
        offer.bank_offer_name = baseOffer.bank_offer_name;
        offer.bank_id = baseOffer.bank_id;
        offer.commission = baseOffer.commission;
        offer.margin = baseOffer.margin;
        offer.wibor = baseOffer.wibor;
        offer.lending_rate = baseOffer.lending_rate;
        offer.fixed_lending_rate = baseOffer.fixed_lending_rate;
        offer.bridging_insurance = baseOffer.bridging_insurance_text;
        offer.life_insurance = baseOffer.life_insurance_text;
        offer.work_insurance = baseOffer.work_insurance_text;
        offer.property_insurance = baseOffer.property_insurance_text;
        offer.valuation = baseOffer.valuation_text;
        offer.early_repayment = baseOffer.early_repayment_text;
        offer.early_overpayment = baseOffer.early_overpayment_text;
      }


      Vue.nextTick(() => {
        this.data.offers.push(offer);
      })
    },
    removeBankOfferFromOffer (offerID, variantID = null) {
      let offerIndex = null;

      if (variantID) {
        offerIndex = this.data.offers.findIndex(item => item.bank_offer_id === offerID && item.bank_offer_variant_id === variantID);
      } else {
        offerIndex = this.data.offers.findIndex(item => item.bank_offer_id === offerID);
      }

      if (offerIndex === null || offerIndex === undefined || offerIndex < 0) {
        return;
      }

      Vue.nextTick(() => {
        this.data.offers.splice(offerIndex, 1);
      })
    },
    calculateLoanInstallment (type = null) {
      for (let i = 0; i < this.data.offers.length; i++) {
        let offer = this.data.offers[i];

        let lendingRate = offer.lending_rate;

        if (type === 'fixed') {
          lendingRate = offer.fixed_lending_rate;
        }

        if (lendingRate && lendingRate >= 0) {
          let requestParams = {
            type: 'EQUAL',
            credit_amount: this.data.credit_amount,
            years: 25,
            lending_rate: lendingRate
          }

          FormUtils.loadAdditionalData(this, {
            method: 'get',
            endpoint: '/api/loan-calculator/calculate',
            loadedKey: 'offerLoanInstallmentLoaded',
            pagination: false,
            params: requestParams,
            successAction: (response) => {
              if (type === 'fixed') {
                offer.fixed_loan_installment = response.instalments[0].month_instalment;
              } else {
                offer.loan_installment = response.instalments[0].month_instalment;
              }
            }
          });
        }
      }
    },
    recalculateCreaditAmount () {
      Vue.nextTick(() => {
        if (!this.data) {
          this.data.credit_amount = 0;
          return;
        }

        let loanAmount = Number(this.data.property_value) + Number(this.data.need_finishing_amount);
        let ownContribution = this.data.own_contribution > 0 ? (this.data.own_contribution / 100) * loanAmount : 0;
        this.data.credit_amount = Number((loanAmount - ownContribution).toFixed(2));
      });
    },
    showNextItem () {
      Vue.nextTick(() => {
        if (this.currentSliderItem < this.data.offers.length) {
          Vue.set(this, 'currentSliderItem', this.currentSliderItem + 1);
        }
      });
    },
    showPrevItem () {
      Vue.nextTick(() => {
        if (this.currentSliderItem > 0) {
          Vue.set(this, 'currentSliderItem', this.currentSliderItem - 1);
        }
      });
    },
    onOffersListToggle (newValue) {
      Vue.nextTick(() => {
        Vue.set(this, 'offersListVisible', newValue);
      });
    },
    getSliderList () {
      if (!this.loaded || !this.offersListVisible || !this.$refs || !this.$refs['offers-slider']) {
        return null;
      }

      let sliderList = this.$refs['offers-slider'];

      if (Array.isArray(sliderList)) {
        sliderList = sliderList[0];
      }

      return sliderList;
    },
    showValidationFailed () {
      this.$refs['accordion-item-offers'].open();
      setTimeout(() => {
        if (this.$refs['accordion-item-offers'].$el.querySelector('.is-invalid')) {
          this.$refs['accordion-item-offers'].$el.querySelector('.is-invalid').scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
        }
      }, 410);
    },
    debouncedResizeHandler: debounce(function () {
      Vue.set(this, 'windowWidth', window.innerWidth);
      Vue.set(this, 'currentSliderItem', 0);
      if (this.sliderList) {
        setTimeout(() => {
          let item = this.sliderList.querySelector('.row-slider .offers-table-row-cell');
          if (item) {
            Vue.set(this, 'sliderItemWidth', item.offsetWidth);
          }
        }, 220);
      }
    }, 250)
  },
  beforeDestroy () {
    this.$bus.$off('offer-selected', this.selectOffer);
    window.removeEventListener('resize', this.debouncedResizeHandler);
  }
}
</script>
